import networkService from '../Network/NetworkManager';
import {fetch_all_categories} from '../utils/fetch_all_categories';
const APPURL = require('../Constants/URLConstants');

//

export const getAllUsers = async ({search = ''} = {}) => {
  const searchQuery = search.trim()
    ? `&search_key=${encodeURIComponent(search.trim())}`
    : '';
  const responseJson = await networkService.networkCall(
    APPURL.URLPaths.user + `?page=1&per_page=100&sort=newest_first${searchQuery}`,
    'get',
    '',
    '',
  );

  if (responseJson?.status == true) {
    var list = responseJson?.data?.users ?? [];
    return list;
  } else {
    return [];
  }
};
